import React, { Suspense } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Route, Switch, Redirect, NotFound } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { NoticeLoading } from '@fs/zion-icon'
import AdminConsole from './pages/AdminConsole'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

const Portal = React.lazy(() => import('./pages/PortalPage/PortalPage'))
const PremiumSites = React.lazy(() => import('./pages/PremiumSitesPage/PremiumSitesPage'))

function App() {
  const queryClient = new QueryClient()
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<NoticeLoading />}>
          <Switch>
            <Route path="/centers/portal" component={Portal} />
            <Route path="/centers/premium-sites" component={PremiumSites} />
            <Route path="/centers/admin" component={AdminConsole} />
            <Redirect exact from="/" to="/centers/portal" />
            <Redirect exact from="/fhcenters/portal" to="/centers/portal" />
            <Redirect exact from="/fhcenters/premium-sites" to="/centers/premium-sites" />
            <Redirect exact from="/fhcenters/admin" to="/centers/admin" />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
export default App
